import { Context } from '@opentelemetry/api';
import { getContext, GetContextEffect } from 'redux-saga/effects';

export function* traceContext(): Generator<GetContextEffect, Context, Context> {
  return yield getContext('trace');
}
